import { Theme } from '@mui/material';

/**
 * The colours the top bar is painted in, derived from whichever theme is active.
 *
 * The bar must not assume white text. `nanoDarkTheme` sets primary.main to
 * '#f9fafb' -- a near-white -- and a hard-coded white foreground over that band
 * would be invisible. So the foreground is asked for, not assumed: MUI's
 * getContrastText picks black or white against the band's own mid colour, and
 * every translucent overlay on the bar is tinted with that same answer.
 */
export const appBarColors = (theme: Theme) => {
    const from = theme.palette.primary.dark;
    const mid = theme.palette.primary.main;
    const to = theme.palette.secondary.main;
    const fg = theme.palette.getContrastText(mid);

    return { from, mid, to, fg };
};

/**
 * The colours the sidebar is painted in.
 *
 * The sidebar used to be a flat '#02384d' hard-coded in App.css, with white
 * text forced on top of it -- which is why the school name rendered in an
 * unreadable dark colour: it was a Typography that none of those overrides
 * happened to catch. The band is now derived here and the foreground asked for
 * once, so nothing inside has to guess what it is sitting on.
 */
export const sidebarColors = (theme: Theme) => {
    const top = theme.palette.primary.dark;
    const bottom = theme.palette.mode === 'dark'
        ? theme.palette.background.paper
        : theme.palette.primary.main;
    const fg = theme.palette.getContrastText(top);

    return { top, bottom, fg };
};
